import React, { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function LanguageSwitcher({ compact = false, className = "" }) {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded text-[#c5a76f] hover:text-[#d8bd86] text-sm font-medium tracking-widest transition-colors ${
          compact ? "" : "border border-[#c5a76f]/30 hover:border-[#c5a76f]"
        }`}
        aria-label="Language"
      >
        {compact ? <Globe className="w-4 h-4" /> : null}
        <span>{current.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 bg-[#242424] border border-[#c5a76f]/25 rounded-md shadow-xl min-w-[160px] py-2 z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between gap-3 px-4 py-2 text-sm transition-colors ${
                l.code === lang
                  ? "text-[#c5a76f] bg-white/[0.03]"
                  : "text-white/80 hover:text-[#c5a76f] hover:bg-white/[0.03]"
              }`}
            >
              <span>
                <span className="font-semibold tracking-widest text-xs mr-2">{l.label}</span>
                {l.name}
              </span>
              {l.code === lang && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
